import { Component } from '@angular/core';

@Component({
  selector: 'app-divider-vehicle',
  template: '<div class="divider"></div>',
  styleUrls: ['./divider-vehicle.component.scss'],
})
export class DividerVehicleComponent {}
